export const GET_PROGRESSNOTE_SETTING = "GET_PROGRESSNOTE_SETTING";
export const GET_PROGRESSNOTE_DETAILS = "GET_PROGRESSNOTE_DETAILS";
export const GET_PROGRESSNOTE_DETAILS_STATUS = "GET_PROGRESSNOTE_DETAILS_STATUS";
export const GET_PROGRESSNOTES = "GET_PROGRESSNOTES";
export const GET_ADMIN_NOTES = "GET_ADMIN_NOTES";
export const GET_DEFAULT_PROGRESSNOTE = "GET_DEFAULT_PROGRESSNOTE";
export const REMOVE_NOTE = "REMOVE_NOTE";
export const GET_ADMIN_PROGRESSNOTE_SETTING = "GET_ADMIN_PROGRESSNOTE_SETTING";
